export default function (element, data) {
    const links = element.querySelectorAll(".navigation-link");

    function updateActiveLink() {
        const validLinks = Array.from(links).filter(link => {
            const href = link.getAttribute('href');
            return href && href.startsWith('#') && document.getElementById(href.substring(1));
        });

        if (!validLinks.length) return;

        let activeLink = null;

        for (const link of validLinks) {
            const rect = document.getElementById(link.getAttribute('href').substring(1)).getBoundingClientRect();
            if (rect.top <= 100) {
                activeLink = link;
            }
        }

        // Насыщение на края: если ни один блок не достиг порога — первый,
        // если скролл ушёл ниже всех блоков — последний (уже назначен выше).
        if (!activeLink) {
            activeLink = validLinks[0];
        }

        links.forEach(link => link.classList.remove('active'));
        activeLink.classList.add('active');
    }

    window.addEventListener('scroll', updateActiveLink, { passive: true });

    updateActiveLink();
}
